'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DOCIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DOCIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Office-File-Text--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Office File Text Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M21.207 4.5a1 1 0 0 1 0.293 0.707V22.5a1 1 0 0 1 -1 1h-17a1 1 0 0 1 -1 -1v-21a1 1 0 0 1 1 -1h13.293a1 1 0 0 1 0.707 0.291Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14.5 5.499 4 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m5.5 14.499 13 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m5.5 17.499 13 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m5.5 20.499 13 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14.5 8.499 4 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14.5 11.499 4 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m5.5 5.499 0 -1 6 0 0 1"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m8.5 4.499 0 7"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6.5 11.499 4 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

DOCIcon.propTypes = {
  sx: PropTypes.object
}
